let save_cart = false;

setCartWidth = () => {
    if ($(window).width() < 768) {
        $('body #shopify-section-header > .cart .cart_inner').css('width', $(window).width() + 'px');
    } else {
        const width = (($(window).actual('width') - 8) / 4 * 2);
        $('body #shopify-section-header > .cart .cart_inner').css('width', width + 'px');
    }
};

setMenuWidth = () => {
    if ($(window).width() < 768) {
        $('.navigation .navigation_inner').css('width', $(window).width() + 'px');
    } else if ($(window).width() < 1200) {
        const width = (($(window).actual('width') - 8) / 4 * 2);
        $('.navigation .navigation_inner').css('width', width + "px");
    } else {
        const width = ((($(window).actual('width') - 8) / 4) + 3);
        $('.navigation .navigation_inner').css('width', width + "px");
    }
};

$(document).ready(function() {
    setCartWidth();
    $(window).on('resize', setCartWidth);
    setMenuWidth();
    $(window).on('resize', setMenuWidth);
    searchFuncs();
});

$('.header .menu').on('click', function(e) {
    e.preventDefault();
    $('.navigation').toggleClass('navigation--open');
});

$('.header .cart_btn').on('click', function(e) {
    e.preventDefault();
    $('.cart').toggleClass('cart--open');
});

$('.navigation .close_btn').on('click', function(e) {
    e.preventDefault();
    $('.navigation').toggleClass('navigation--open');
});

$('.cart .close_btn').on('click', function(e) {
    e.preventDefault();
    $('.cart').toggleClass('cart--open');
});

$('.navigation .navigation_menu > ul > li > a').on('click', function(e) {
    if ($(this).closest('li').find('ul').length === 1) {
        e.preventDefault();
        $(this).closest('li').toggleClass('open');
    }
});

$('.navigation .navigation_menu .currencies_menu > li > ul > li > a').on('click', function(e) {
    e.preventDefault();
        
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'currency': $(this).data('currency') })
    }).then(response => {
        window.location.reload();
    }).catch((error) => {
        console.error('Error:', error);
    });
})

$('.cart .cart_inner').on('click', '.remove_btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const updates = { [$(this).closest('.cart_row').data('variantid')] : 0 };
    const that = $(this).closest('.cart_row');
    if (!save_cart) {
        save_cart = true;

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        })
        .then(response => {
            $.ajax({
                url: '/',
                success: function(res) {
                    $('.cart_btn').html($(res).find('.cart_btn').html());
                    $('.cart .cart_inner .cart_content').html($(res).find('.cart_content').html());
                    save_cart = false;
                },
                error: function() {
                    save_cart = false;
                }
            })
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
});

const searchFuncs = () => {
    if ($('.navigation_inner_search_bottom > div.active').length > 0) {
        gsap.timeline().to(".navigation .navigation_inner_search", { duration: 0, height: "auto", ease: "power4.out" });
    }
    
    $('.navigation .navigation_inner_search input').on('focus', function() {
        gsap.timeline().to(".navigation .navigation_inner_search", { duration: .5, height: "auto", ease: "power4.out" });
    })

    $('.navigation .navigation_inner_search').on('submit', function(e) {
        e.preventDefault();
        const action    = $(this).attr('action');
        const sizeval   = $(this).find('.navigation_inner_search_bottom > div.active').length > 0 ? getSizes() : false;
        const searchval = $(this).find('input').val() !== '' ? $(this).find('input').val() : false;
        const searchurl = new URL(window.shopUrl + action);
        
        let sizes = false;
        if (sizeval) {
            sizes = "";
            sizeval.map((size, sk) => {
                sizes += "variants.title:" + size;
                if (sk < sizeval.length - 1) sizes += " OR ";
            });
        }

        if (sizeval && sizes && searchval) {
            searchurl.searchParams.append("q", searchval + " AND " + sizes);
        } else if (!sizeval && searchval) {
            searchurl.searchParams.append("q", searchval);
        } else if (sizeval && sizes && !searchval) {
            searchurl.searchParams.append("q", sizes);
        } else {
            searchurl.searchParams.append("q", '');
        }
        
        searchurl.searchParams.append("type", "product");
        window.location.href = searchurl.href;
    });

    $('.navigation .navigation_inner_search .navigation_inner_search_bottom > div').on('click', function(e) {
        $(this).toggleClass('active');
        $(this).closest('form').submit();
    });

    const getSizes = () => {
        let sizes = [];
        $('.navigation_inner_search_bottom > div.active').each(function() {
            sizes.push($(this).data('size'));
        });

        return sizes;
    }
}